import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://innovanow.com.br';

export default function SeoHead({
  path,
  title,
  description,
  keywords,
  ogImage = `${SITE_URL}/assets/images/appdevendaspersonalizado.png`,
  jsonLd = [],
}) {
  const url = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <link rel="canonical" href={url} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content="pt_BR" />
      <meta property="og:site_name" content="(in)nova now" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      {jsonLd.map((schema, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
}
